import Ajax from '../ajax';

export default {
  typeList: () => Ajax('get', 'swapin/category'),
  typeAdd: (data) => Ajax('post', 'swapin/category', data),
  typeEdit: (catId, data) => Ajax('put', `swapin/category/${catId}`, data),
  typeDelete: (catId) => Ajax('delete', `swapin/category/${catId}`),

  itemList: (data) => Ajax('get', 'swapin/item/list/0', data || { pageNo: 1 }),
  itemGet: (itemId) => Ajax('get', `swapin/item/${itemId}`),
  itemAdd: (data) => Ajax('post', 'swapin/item', data),
  itemEdit: (data) => Ajax('put', 'swapin/item', data),
  itemModifyRateStatus: (itemId, isEnable) => Ajax('put', `swapin/item/enable/${itemId}?isEnable=${isEnable}`),
  itemEditExchangeRate: (itemId, rate) => Ajax('put', `swapin/item/rateedit/${itemId}?rate=${rate}`),
  itemEditLowestExchangeRate: (itemId, rate) => Ajax('put', `swapin/item/lowestrateedit/${itemId}?rate=${rate}`),
  itemEditHighestExchangeRate: (itemId, rate) => Ajax('put', `swapin/item/highestrateedit/${itemId}?rate=${rate}`),
  itemLogList: (itemId) => Ajax('get', `swapin/item/ratelist/${itemId}`),
};
